import React, { useEffect, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { Plus, Edit, X, Save, Trash2, ChevronDown, ChevronUp } from "react-feather";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Dropdown from "react-bootstrap/Dropdown";
import {
  createUnit,
  updateUnit,
  updateComponent,
  getCourseById,
  deleteComponent,
  deleteUnit,
  createQuiz,
  createComponent,
  updateCourse,
  // createQuestion,
  // createOption,
} from "../../../services/labServices";
import UnitsDnd from "../unitsDnD";
import { handleErrors } from "../../../services/handleErrors";
import FormVideoComponent from "../videoComponent";
import FormPdfComponent from "../pdfComponent";
import { BlurSpinner } from "../../BlurSpinner";
import PopupDelete from "../deletePopUp";
import QuizComponent from "../quiz";
import { UnitTitleContainer, UnitTitleInput, UnitContainer, UnitTitle, UnitIndex, OptionType, OptionContainer } from "./styles";
import { Toggle } from "../courseCategories/styles";
import "../courseStyles.scss";

export default function CourseUnitsAndComponents({ course, readOnly }) {
  const [unidades, setUnidades] = useState([]);
  const [unitInfo, setUnitInfo] = useState({});
  const [componentInfo, setComponentInfo] = useState({});
  const [modifyingUnitTitle, setModifyingUnitTitle] = useState(false);
  const [componentForm, setComponentForm] = useState(null);
  const [newComponent, setNewComponent] = useState(null);
  const [reloadData, setReloadData] = useState(false);
  const [deleteUnitPopUp, setDeleteUnitPopUp] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isCreatingComponent, setIsCreatingComponent] = useState(false);
  const [openQuiz, setOpenQuiz] = useState(false);

  const maxComponents = 4;
  const currentUnit = unidades.find((unit) => unit.id === unitInfo.id);
  const totalComponentsOfCurrentUnit = (currentUnit && currentUnit.labComponent && currentUnit.labComponent.length) || 0;

  const lastUnit = unidades[unidades.length - 1];

  const handleAddUnit = async () => {
    if (unidades.length === 0) {
      try {
        await createUnit({ title: "Unidad 1", course_id: course.id, sort_order: 1 });
      } catch (error) {
        handleErrors(error, toast.error);
      }
      setReloadData(true);
    } else if (lastUnit && lastUnit.labComponent && lastUnit.labComponent.length > 0) {
      try {
        await createUnit({ title: `Unidad ${unidades.length + 1}`, course_id: course.id, sort_order: unidades.length + 1 });
      } catch (error) {
        handleErrors(error, toast.error);
      }

      setReloadData(true);
    } else {
      toast.error("Debe crear un componente antes de crear una nueva unidad");
    }
  };

  useEffect(async () => {
    if (course && course.labUnit) {
      setUnidades(course.labUnit);
    }

    if (course && course.total_components === null) {
      const res = await getCourseById(course.id);
      const currentCourse = res.result.rows[0];
      // actualizar el total de componentes
      const componentsArray = currentCourse.labUnit.map((unidad) => unidad.labComponent.length);
      const componentsLength = componentsArray.reduce((a, b) => a + b, 0);
      try {
        await updateCourse(course.id, { total_components: componentsLength });
        // eslint-disable-next-line no-console
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }
  }, [course]);

  useEffect(async () => {
    if (course && course.id) {
      const res = await getCourseById(course.id);
      const currentCourse = res.result.rows[0];
      setUnidades(currentCourse.labUnit);
      setReloadData(false);

      // actualizar el total de componentes
      const componentsArray = currentCourse.labUnit.map((unidad) => unidad.labComponent.length);
      const componentsLength = componentsArray.reduce((a, b) => a + b, 0);
      try {
        await updateCourse(course.id, { total_components: componentsLength });
      } catch (error) {
        handleErrors(error, toast.error);
      }

      // para abrir el quiz despues de crearlo
      if (openQuiz) {
        const thisUnit = currentCourse.labUnit.find((unit) => unit.id === unitInfo.id);
        const quizInfo = thisUnit.labComponent.find((component) => component.type === "Quiz");
        setComponentInfo(quizInfo);
        setComponentForm(quizInfo.type);
        setOpenQuiz(false);
      }
    }
  }, [reloadData === true || newComponent]);

  useEffect(() => {
    if (componentInfo) {
      setComponentForm(componentInfo.type);
    }
  }, [componentInfo]);

  const formik = useFormik({
    initialValues: {
      title: unitInfo.title || "",
    },

    onSubmit: async (values) => {
      const dataToupdateUnit = {
        title: values.title,
        sort_order: unitInfo.order,
      };

      try {
        const res = await updateUnit(unitInfo.id, dataToupdateUnit);
        const updatedUnit = res.result;

        setUnitInfo(updatedUnit);
        setReloadData(true);
        toast.success("Guardado con exito");
        setModifyingUnitTitle(false);
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
        setModifyingUnitTitle(false);
      }
    },
    validationSchema: Yup.object().shape({
      title: Yup.string().required("Este campo es requerido."),
    }),
  });

  useEffect(() => {
    if (totalComponentsOfCurrentUnit === 0) {
      setComponentInfo(null);
      setComponentForm("PDF");
    }

    formik.setFieldValue("title", unitInfo.title);
  }, [unitInfo]);

  const handleDeleteUnit = async (id) => {
    //
    try {
      await deleteUnit(id);
      // busca las unidades que quedan, las ordena y actualiza los sort_order
      const { result } = await getCourseById(course.id);
      const currentCourse = result.rows[0];
      const unitsIdsList = currentCourse.labUnit.sort((a, b) => a.sort_order - b.sort_order).map((unit) => unit.id);
      try {
        unitsIdsList.forEach(async (unit, index) => {
          await updateUnit(unit, { sort_order: index + 1 });
        });
      } catch (error) {
        handleErrors(error, toast.error);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }
    setComponentForm(null);
    setUnitInfo({});
    setReloadData(true);
  };

  const handleDeleteComponent = async (id) => {
    //
    try {
      await deleteComponent(id);
      // busca los componentes que quedan, los ordena y actualiza los sort_order
      const componentsIdsList = unitInfo.components
        .filter((component) => component.id !== id)
        .sort((a, b) => a.sort_order - b.sort_order)
        .map((component) => component.id);
      try {
        componentsIdsList.forEach(async (component, index) => {
          await updateComponent(component, { sort_order: index + 1 });
        });
      } catch (error) {
        handleErrors(error, toast.error);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }
    setReloadData(true);
    setComponentForm(null);
  };

  const handleAddQuiz = async () => {
    setIsCreatingComponent(true);
    if (unitInfo.components.some((component) => component.type === "Quiz")) {
      toast.error("No se puede crear más de un componente Quiz por unidad");
    } else {
      const dataComponent = {
        unit_id: unitInfo.id,
        type: "Quiz",
        // el titulo del componente quiz se cambia a Test
        title: `Test`,
        sort_order: (unitInfo.components && unitInfo.components.length + 1) || 1,
      };
      try {
        const { result } = await createComponent(dataComponent);
        try {
          await createQuiz(result.id);
          // const response = await createQuiz(result.id);

          // const data = {
          //   quiz_id: response.result.id,
          //   type_quiz: "TORF",
          //   question_text: "pregunta",
          // };
          // try {
          //   const res = await createQuestion(data);

          //   try {
          //     await createOption({
          //       question_id: res.result.id,
          //       is_correct: true,
          //       option_text: "verdadero",
          //     });

          //     try {
          //       await createOption({
          //         question_id: res.result.id,
          //         is_correct: false,
          //         option_text: "falso",
          //       });
          //     } catch (error) {
          //       handleErrors(error, toast.error);
          //     }
          //   } catch (error) {
          //     handleErrors(error, toast.error);
          //   }
          // } catch (error) {
          //   handleErrors(error, toast.error);
          // }
        } catch (error) {
          handleErrors(error, toast.error);
        }

        toast.success("Componente Quiz creado correctamente");
        // setComponentForm(null);
        setReloadData(true);

        setReloadData(true);
        setIsCreatingComponent(false);
        setOpenQuiz(true);
      } catch (error) {
        handleErrors(error, toast.error);
      }
    }

    setIsOpen(!isOpen);
  };

  return (
    <>
      {deleteUnitPopUp && (
        <PopupDelete isOpen={deleteUnit} toggle={() => setDeleteUnitPopUp(!deleteUnitPopUp)} elementToDelete={unitInfo} type="unit" handleDelete={handleDeleteUnit} />
      )}
      <div className="container-fluid">
        <div className="row">
          {course && course.id ? (
            <>
              <div className="col-lg-4">
                <div className="card">
                  <div className="card-body">
                    <BlurSpinner isLoading={reloadData}>
                      <div className="card-title d-flex justify-content-between align-items-center mx-3">
                        <h2>Unidades</h2>
                        <UncontrolledTooltip target="btnAddUnit">Añadir nueva unidad</UncontrolledTooltip>
                        <Button size="xs" color="link" type="button" id="btnAddUnit" onClick={handleAddUnit} disabled={readOnly}>
                          <Plus size="22" color={readOnly ? "gray" : "green"} />
                        </Button>
                      </div>
                    </BlurSpinner>
                    <UnitsDnd
                      unidades={unidades}
                      setUnitInfo={setUnitInfo}
                      newComponent={newComponent}
                      setComponenInfo={setComponentInfo}
                      setReloadData={setReloadData}
                      setComponentForm={setComponentForm}
                      readOnly={readOnly}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="conteiner-fluid w-100">
                  <div className="card">
                    <div className="card-body">
                      <UnitContainer>
                        <UnitIndex>{unitInfo.order}</UnitIndex>
                        <UnitTitleContainer onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                          {modifyingUnitTitle ? (
                            <form className="theme-form w-100" onSubmit={formik.handleSubmit}>
                              <div className="d-flex justify-content-between w-100" style={{ height: "40px" }}>
                                <UnitTitleInput
                                  type="text"
                                  id="title"
                                  disabled={formik.isSubmitting}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.title}
                                  maxLength={100}
                                  placeholder={formik.errors.title && formik.touched.title ? "Campo requerido" : ""}
                                  style={formik.errors.title && formik.touched.title ? { borderBottom: "1px solid red" } : null}
                                />
                                <div className="d-flex p-0 m-0">
                                  <UncontrolledTooltip target="btnConfirmarEditUnitTitle">Guardar cambios</UncontrolledTooltip>
                                  <Button size="xs" color="link" type="submit" id="btnConfirmarEditUnitTitle">
                                    <Save size="22" color="green" />
                                  </Button>
                                  <UncontrolledTooltip target="btnCancelarEditTitle">Cancelar</UncontrolledTooltip>
                                  <Button size="xs" color="link" type="button" id="btnCancelarEditTitle" onClick={() => setModifyingUnitTitle(!modifyingUnitTitle)}>
                                    <X size="22" color="black" />
                                  </Button>
                                </div>
                              </div>
                            </form>
                          ) : (
                            <>
                              <UnitTitle>{unitInfo.title || "Sin información"}</UnitTitle>
                              {isHovered && (
                                <div>
                                  <div className="d-flex">
                                    <>
                                      <UncontrolledTooltip target="btnEditUnitTitle">Editar unidad</UncontrolledTooltip>
                                      <Button
                                        size="xs"
                                        id="btnEditUnitTitle"
                                        color="link"
                                        onClick={() => setModifyingUnitTitle(!modifyingUnitTitle)}
                                        // disabled={!(unitInfo && unitInfo.components
                                        // && unitInfo.components.length > 0) || readOnly}
                                        // se habilita la edicion de titulo sin componentes creados
                                        disabled={!unitInfo || readOnly}
                                      >
                                        <Edit size="20" color="black" />
                                      </Button>
                                    </>
                                    <UncontrolledTooltip target="btnDeleteUnidad">Eliminar unidad</UncontrolledTooltip>
                                    <Button size="xs" id="btnDeleteUnidad" color="link" onClick={() => setDeleteUnitPopUp(true)} disabled={!unitInfo.title || readOnly}>
                                      <Trash2 size="20" color="black" />
                                    </Button>
                                  </div>
                                </div>
                              )}
                            </>
                          )}
                        </UnitTitleContainer>
                      </UnitContainer>
                      <div className="mb-3" style={{ minHeight: "calc(100vh - 640px)", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                        {componentForm === "Video" && (
                          <FormVideoComponent
                            componentList={currentUnit && currentUnit.labComponent}
                            componentInfo={componentInfo}
                            unitId={unitInfo.id}
                            setComponentForm={setComponentForm}
                            setReloadData={setReloadData}
                            handleDelete={handleDeleteComponent}
                            readOnly={readOnly}
                          />
                        )}
                        {componentForm === "PDF" && (
                          <FormPdfComponent
                            componentList={currentUnit && currentUnit.labComponent}
                            componentInfo={componentInfo}
                            unitId={unitInfo.id}
                            setNewComponent={setNewComponent}
                            handleDelete={handleDeleteComponent}
                            setReloadData={setReloadData}
                            setComponentForm={setComponentForm}
                            readOnly={readOnly}
                          />
                        )}
                        {componentForm === "Quiz" && (
                          <QuizComponent
                            handleDelete={handleDeleteComponent}
                            componentInfo={componentInfo}
                            setNewComponent={setNewComponent}
                            setReloadData={setReloadData}
                            unitInfo={unitInfo}
                            setComponentForm={setComponentForm}
                          />
                        )}

                        <div className="mt-2 d-flex align-items-center">
                          {totalComponentsOfCurrentUnit > maxComponents ? (
                            <p className="p-1 mx-1">No puedes agregar más componentes</p>
                          ) : (
                            <Dropdown show={isOpen}>
                              <Toggle size="xs" type="button" onClick={() => setIsOpen(!isOpen)} disabled={readOnly}>
                                <div className="d-flex align-items-center justify-content-between px-3">
                                  <p className="m-0">Tipo de componente</p>
                                  {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                                </div>
                              </Toggle>
                              <Dropdown.Menu
                                show={isOpen}
                                id="dropdown-component_type"
                                align="start"
                                style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", zIndex: "10" }}
                              >
                                <BlurSpinner isLoading={isCreatingComponent}>
                                  <OptionContainer>
                                    <OptionType
                                      onClick={() => {
                                        setComponentForm("Video");
                                        setComponentInfo(null);
                                        setIsOpen(!isOpen);
                                      }}
                                    >
                                      Video
                                    </OptionType>
                                    <OptionType
                                      onClick={() => {
                                        setComponentForm("PDF");
                                        setComponentInfo(null);
                                        setIsOpen(!isOpen);
                                      }}
                                    >
                                      PDF
                                    </OptionType>

                                    <OptionType onClick={handleAddQuiz}>Quiz</OptionType>
                                  </OptionContainer>
                                </BlurSpinner>
                              </Dropdown.Menu>
                            </Dropdown>
                          )}
                          {componentForm !== "Video" && componentForm !== "PDF" && componentForm !== "Quiz" && (
                            <p className="mx-2">Presiona ponente para abrir el formulario</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="card-title d-flex flex-column justify-content-start align-items-start mx-3">
                    <h2>Unidades</h2>
                    <p className="card-text mt-2">Para comenzar a crear tus unidades, primero debes guardar el título y descripción del curso.</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
